/** @returns {EventTarget|null} */
export function visualViewportEventTarget() {
    return globalThis.visualViewport ?? null;
}

/** @returns {EventTarget|null} */
export function virtualKeyboardEventTarget() {
    return globalThis.navigator?.virtualKeyboard ?? null;
}

/** @returns {number} */
export function browserKeyboardBottomInset() {
    if (!isTextInputFocused()) return 0;

    const visualViewport = globalThis.visualViewport;
    const visualViewportInset = visualViewport
        ? Math.max(
            0,
            globalThis.innerHeight - visualViewport.height - visualViewport.offsetTop,
        )
        : 0;
    const virtualKeyboardInset =
        globalThis.navigator?.virtualKeyboard?.boundingRect?.height || 0;
    return Math.max(visualViewportInset, virtualKeyboardInset);
}

/** @returns {boolean} */
export function browserTextInputFocused() {
    return isTextInputFocused();
}

/** @returns {boolean} */
function isTextInputFocused() {
    let activeElement = globalThis.document?.activeElement;
    while (activeElement?.shadowRoot?.activeElement) {
        activeElement = activeElement.shadowRoot.activeElement;
    }

    const tagName = activeElement?.tagName;
    return tagName === "INPUT" ||
        tagName === "TEXTAREA" ||
        activeElement?.isContentEditable === true;
}
